export default __webpack_public_path__ + "static/media/code_jd_al_gfqjd2.67f48e76.png";